import { muiTheme as theme } from '@/theme';

const baseRainbow: any = {
  blurs: {
    modalOverlay: 'blur(2px)',
  },
  fonts: {
    body: theme.typography.fontFamily,
  },
  radii: {
    actionButton: `${theme.shape.borderRadius}px`,
    connectButton: `${theme.shape.borderRadius}px`,
    menuButton: `${theme.shape.borderRadius}px`,
    modal: `${theme.shape.borderRadius}px`,
    modalMobile: `${theme.shape.borderRadius}px`,
  },
};

export const darkRainbow = {
  ...baseRainbow,
  colors: {
    accentColor: theme.colorSchemes.dark!.palette.primary.main,
    accentColorForeground: theme.colorSchemes.dark!.palette.primary.contrastText,
    actionButtonBorder: theme.colorSchemes.dark!.palette.elevation.outlined,
    actionButtonBorderMobile: theme.colorSchemes.dark!.palette.elevation.outlined,
    actionButtonSecondaryBackground: theme.colorSchemes.dark!.palette.background['paper-elevation-1']!,
    closeButton: theme.colorSchemes.dark!.palette.text.primary,
    closeButtonBackground: theme.colorSchemes.dark!.palette.background['paper-elevation-0']!,
    connectButtonBackground: theme.colorSchemes.dark!.palette.primary.main,
    connectButtonBackgroundError: theme.colorSchemes.dark!.palette.error.main,
    connectButtonInnerBackground: theme.colorSchemes.dark!.palette.background['paper-elevation-2']!,
    connectButtonText: theme.colorSchemes.dark!.palette.primary.contrastText,
    connectButtonTextError: theme.colorSchemes.dark!.palette.error.contrastText,
    connectionIndicator: theme.colorSchemes.dark!.palette.success.main,
    error: theme.colorSchemes.dark!.palette.error.main,
    generalBorder: theme.colorSchemes.dark!.palette.elevation.outlined,
    generalBorderDim: theme.colorSchemes.dark!.palette.elevation.outlined,
    menuItemBackground: theme.colorSchemes.dark!.palette.background['paper-elevation-1']!,
    modalBackdrop: 'rgba(0, 0, 0, 0.5)',
    modalBackground: theme.colorSchemes.dark!.palette.background['paper-elevation-3']!,
    modalBorder: theme.colorSchemes.dark!.palette.elevation.outlined,
    modalText: theme.colorSchemes.dark!.palette.text.primary,
    modalTextDim: theme.colorSchemes.dark!.palette.text.secondary,
    modalTextSecondary: theme.colorSchemes.dark!.palette.text.secondary,
    profileAction: theme.colorSchemes.dark!.palette.background['paper-elevation-1']!,
    profileActionHover: theme.colorSchemes.dark!.palette.background['paper-elevation-2'],
    profileForeground: theme.colorSchemes.dark!.palette.background['paper-elevation-2'],
    selectedOptionBorder: theme.colorSchemes.dark!.palette.primary.main,
    standby: theme.colorSchemes.dark!.palette.warning.main,
    downloadBottomCardBackground: theme.colorSchemes.dark!.palette.background['paper-elevation-1']!,
    downloadTopCardBackground: theme.colorSchemes.dark!.palette.background['paper-elevation-3']!,
  },
};
export const lightRainbow: any = {
  ...baseRainbow,
  colors: {
    accentColor: theme.colorSchemes.light!.palette.primary.main,
    accentColorForeground: theme.colorSchemes.light!.palette.primary.contrastText,
    actionButtonBorder: theme.colorSchemes.light!.palette.elevation.outlined,
    actionButtonBorderMobile: theme.colorSchemes.light!.palette.elevation.outlined,
    actionButtonSecondaryBackground: theme.colorSchemes.light!.palette.background['paper-elevation-1']!,
    closeButton: theme.colorSchemes.light!.palette.text.primary,
    closeButtonBackground: theme.colorSchemes.light!.palette.background['paper-elevation-0']!,
    connectButtonBackground: theme.colorSchemes.light!.palette.primary.main,
    connectButtonBackgroundError: theme.colorSchemes.light!.palette.error.main,
    connectButtonInnerBackground: theme.colorSchemes.light!.palette.background['paper-elevation-2']!,
    connectButtonText: theme.colorSchemes.light!.palette.primary.contrastText,
    connectButtonTextError: theme.colorSchemes.light!.palette.error.contrastText,
    connectionIndicator: theme.colorSchemes.light!.palette.success.main,
    error: theme.colorSchemes.light!.palette.error.main,
    generalBorder: theme.colorSchemes.light!.palette.elevation.outlined,
    generalBorderDim: theme.colorSchemes.light!.palette.elevation.outlined,
    menuItemBackground: theme.colorSchemes.light!.palette.background['paper-elevation-1']!,
    modalBackdrop: 'rgba(0, 0, 0, 0.3)',
    modalBackground: theme.colorSchemes.light!.palette.background['paper-elevation-3']!,
    modalBorder: theme.colorSchemes.light!.palette.elevation.outlined,
    modalText: theme.colorSchemes.light!.palette.text.primary,
    modalTextDim: theme.colorSchemes.light!.palette.text.secondary,
    modalTextSecondary: theme.colorSchemes.light!.palette.text.secondary,
    profileAction: theme.colorSchemes.light!.palette.background['paper-elevation-1']!,
    profileActionHover: theme.colorSchemes.light!.palette.background['paper-elevation-2'],
    profileForeground: theme.colorSchemes.light!.palette.background['paper-elevation-2'],
    selectedOptionBorder: theme.colorSchemes.light!.palette.primary.main,
    standby: theme.colorSchemes.light!.palette.warning.main,
    downloadBottomCardBackground: theme.colorSchemes.light!.palette.background['paper-elevation-1']!,
    downloadTopCardBackground: theme.colorSchemes.light!.palette.background['paper-elevation-3']!,
  },
};
